module.exports = __webpack_public_path__ + "media/images/emoticons/clover-5aad15170c8e6944138e010f090e0225.gif";